import Vue from 'vue'
import Vuex from 'vuex';
import user from "./modules/user";
import userauth from "./modules/userauth";
import qrcode from "./modules/qrcode";
import personal from "./modules/personal";
import conditions from "./modules/conditions";
import medications from "./modules/medications";
import allergies from "./modules/allergies";
import devices from "./modules/devices";
import vaccinations from "./modules/vaccinations";
import files from "./modules/files";
import econtacts from "./modules/econtacts";
import publics from "./modules/public";
import gp from "./modules/gp";
//import { forEach } from 'core-js/fn/array';
//import axios from "./modules/axios";
//import payments from "./modules/payments";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    messages: [],
    years: [],
    months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  },
  getters: {
    gMessages(state) {
      return state.messages;
    },
    gYears(state) {
      return state.years;
    },
    gMonths(state) {
      return state.months;
    }
  },
  mutations: {
    mMessage(state, value) {
      state.messages = value;
    },
    mClearMessage(state) {
      state.messages = [];
    },
    mYears(state, years) {
      state.years = years;
    },
  },
  actions: {
    aYears({ state, commit }) {
      //if (rootGetters['userauth/gLoggedIn']) {
        if (!state.years.length) {
          var years = [];
          var year = new Date().getFullYear();
          for (var index = year; index > 1900; index--) {
             years.push(index);
          }
          commit('mYears', years);
          /* return new Promise((resolve, reject) => {
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.userauth.token;
            axios.get('profile/getyears')
              .then(response => {
                if (response.data.status) {
                  commit('mYears', response.data.data);
                  resolve(1);
                }
              })
              .catch(error => {
                reject(error);
              })
          }) */
        }
      //}
    },
  },
  modules: {
    user: user, econtacts, publics,
    userauth, qrcode, personal, conditions, medications, allergies, files, devices, vaccinations, gp
  }
})
